var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c("CharacteristicEdit", {
        ref: "edit",
        attrs: {
          title: _vm.title,
          "with-keyword": _vm.withKeyword,
          "characteristic-items": _vm.characteristicItems,
          "characteristic-type": _vm.characteristicType,
          "nothing-allowed": {
            onlyOverall: true,
            overall: {
              text: _vm.nothingOverallText,
              inFan: true
            }
          },
          "supplements-config": _vm.supplementsConfig || {
            disable: true
          },
          "with-experience": _vm.withExperience,
          "with-education": _vm.withEducation,
          "experience-config": {
            noneAllowed: this.experienceNoneAllowed
          },
          "selected-items-config": {
            lastLevelOnly: true,
            flat: true,
            styling: _vm.selectedItemsStyling,
            labelType: _vm.labelTypeApplication,
            sortType: "experience"
          },
          "header-info": _vm.headerInfo,
          "open-fan-label": _vm.openFanLabel,
          "with-edit-button": _vm.withEditButton,
          "group-by-letter": _vm.groupByLetter,
          "search-config": _vm.searchConfig,
          "show-multiple-hint": "",
          "completion-check-config": {
            enabled:
              _vm.completionCheckConfig.enabled !== undefined
                ? _vm.completionCheckConfig.enabled
                : true,
            label: _vm.completionCheckConfig.label,
            okButtonText: _vm.completionCheckConfig.okButtonText,
            popUpInfo: _vm.completionCheckApplicationExperienceInfo
          }
        },
        on: {
          finish: function($event) {
            return _vm.$emit("finish", $event)
          },
          input: function($event) {
            return _vm.$emit("input", $event)
          }
        },
        model: {
          value: _vm.items,
          callback: function($$v) {
            _vm.items = $$v
          },
          expression: "items"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }